<div class="p-404">
  <svg
    fill=""
    stroke="#ffffff"
    stroke-width="0.7"
    viewBox="0 0 300 300"
    xmlns="http://www.w3.org/2000/svg"
    class="p-404__svg">
    <defs>
      <circle id="myCircle" cx="0" cy="0" r="150" />
    </defs>
    <g transform="translate(150, 150)" class="p-404__g-transform">
      <use href="#myCircle" transform="scale(1)" />
      <use href="#myCircle" transform="scale(0.707)" />
      <use href="#myCircle" transform="scale(0.5)" />
      <use href="#myCircle" transform="scale(0.354)" />
      <use href="#myCircle" transform="scale(0.25)" />
      <use href="#myCircle" transform="scale(0.177)" />
      <use href="#myCircle" transform="scale(0.125)" />
      <use href="#myCircle" transform="scale(0.088)" />
      <use href="#myCircle" transform="scale(0.0625)" />
      <use href="#myCircle" transform="scale(0.044)" />
      <use href="#myCircle" transform="scale(0.03125)" />
      <use href="#myCircle" transform="scale(0.022)" />
      <use href="#myCircle" transform="scale(0.016)" />
      <use href="#myCircle" transform="scale(0.011)" />
      <use href="#myCircle" transform="scale(0.008)" />
      <use href="#myCircle" transform="scale(0.005)" />
    </g>
  </svg>
  <div class="p-404__content">
    <div class="p-404__content-info">
      <h1 class="p-404__title">Houston, tenemos un problema</h1>
      <h4 class="p-404__subtitle">
        Error 404, hemos caído en un agujero negro
      </h4>
    </div>

    <app-button
      [titulo]="'Regresar a mapa de crecimiento'"
      (click)="redirectHome()"
      [className]="'quaternary login-button'"
      class="test2"></app-button>
  </div>
</div>
